import { useEffect } from "react";
import NotificationsSettingsTable from "./NotificationsSettingsTable";
import HeaderColumnData from "../../services/models/notificationsSettingsTableModels/headerColumnData.model";
import BodyColumnData from "./BodyColumnData.model";
import NotificationSettingsServices from "../../services/NotificationSettingsServices";
import utils from "../../services/utils";
import useOrganizations from "../../services/utils/custom hooks/useOrganizations";
import useMediumValues from "../../services/utils/custom hooks/Notifications/useMediumValues";
import useOrganizationNotificationMediumValues from "../../services/utils/custom hooks/Notifications/useOrganizationMediumValues";
import NotificationSettingsTableLoadingIndicator from "../global/LoadingIndicators/NotificationsSettingsTableLoadingIndicator";

export interface ActionArgs {
  data?: any;
  onSuccess?: Function;
  onError?: Function;
  config?: any;
}

interface OrganizationsSettingsTableProps {
  tableColumns: HeaderColumnData[];
  tableBody: Array<BodyColumnData[]>;
  setTableBody: (data: Array<BodyColumnData[]>) => void;
  setTableColumns: (data: HeaderColumnData[]) => void;
}

function OrganizationsSettingsTable({
  tableColumns,
  tableBody,
  setTableBody,
  setTableColumns,
}: Readonly<OrganizationsSettingsTableProps>): JSX.Element {
  const { data: organizations, isFetching } = useOrganizations();
  const { data: mediumValues, isFetching: loadingMediums } = useMediumValues();
  const {
    data: organizationValues,
    isLoading: loadingOrganizationMediumValues,
  } = useOrganizationNotificationMediumValues();

  const loading =
    isFetching || loadingMediums || loadingOrganizationMediumValues;

  const NotificationsSettingsData = new NotificationSettingsServices(
    organizations?.data ?? [],
    mediumValues?.data ?? [],
    organizationValues?.data ?? []
  );
  const dispatch = {};
  function handleSelectAll(id: string | number, value?: boolean) {
    setTableBody(
      NotificationsSettingsData.handleSelectAll(
        id,
        tableColumns,
        tableBody,
        dispatch,
        value
      ).tableBody
    );
    setTableColumns(
      NotificationsSettingsData.handleSelectAll(
        id,
        tableColumns,
        tableBody,
        dispatch,
        value
      ).tableColumn
    );
  }

  useEffect(() => {
    if (!loading) {
      NotificationsSettingsData.createOrganizationsSettingsData();
      setTableColumns(
        NotificationsSettingsData.getOrganizationsSettingsData().tableColumn
      );
      setTableBody(
        NotificationsSettingsData.getOrganizationsSettingsData().tableBody
      );
    }
  }, [loading]);

  const filteredValues = utils.getFilteredValues(tableBody);

  if (loading) return <NotificationSettingsTableLoadingIndicator />;

  return (
    <NotificationsSettingsTable
      tableColumns={tableColumns}
      onSelectAll={handleSelectAll}
      tableBody={tableBody}
      setTableBody={setTableBody}
      isEnabled={filteredValues}
    />
  );
}

export default OrganizationsSettingsTable;
